<p-divider></p-divider>

<!-- {{ userEditForm.value| json }} -->

@if (loading)
{
<p><i class="pi pi-spin pi-spinner mr-1" style="font-size: 2rem"></i><span>Bitte warten - Daten werden
        geladen....</span></p>
} @else {

<div>
    <form (ngSubmit)="updateUser()" [formGroup]="userEditForm">

        <div>
            @if (userEditForm.status == 'INVALID')
            {
            <p><b>Bitte alle Pflichtfelder (*) ausfüllen!</b></p>
            } @else {
            <p>Alles ausgefüllt - Bearbeitung kann starten.</p>
            }
            <p-divider></p-divider>
            <div class="p-fluid p-formgrid p-grid">
                <div class="field p-col">
                    <label for="firstname">Vorname *</label>
                    <input id="firstname" type="text" name="firstname" id="firstname" pInputText
                        formControlName="firstname" required>
                    @if (errorMessages['firstname'])
                    {
                    <small class="p-error">{{ errorMessages['firstname'][0]}}</small>
                    }
                </div>
                <div class="field p-col">
                    <label for="lastname">Nachname *</label>
                    <input id="lastname" type="text" name="lastname" id="lastname" pInputText formControlName="lastname"
                        required>
                    @if (errorMessages['lastname'])
                    {
                    <small class="p-error">{{ errorMessages['lastname'][0]}}</small>
                    }
                </div>
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="field p-col">
                    <label for="email">Email-Adresse *</label>
                    <input id="email" type="email" name="email" id="email" pInputText required formControlName="email">
                    @if (errorMessages['email'])
                    {
                    <small class="p-error">{{ errorMessages['email'][0]}}</small>
                    }
                    <!-- <div *ngIf="formerror.email"><small class="p-error">{{ formerror.email[0] }}</small></div> -->
                </div>
            </div>
            <p-divider></p-divider>
            @if (userEditForm.value.usersid == "") {
            <div class="field">
                <label for="password">Initiales Passwort</label>
                <input id="password" type="password" name="password" id="password" pInputText required class="w-full"
                    formControlName="password">
            </div>
            <div class="field">
                <label for="password_confirmation">Initiales Passwort Bestätigung</label>
                <input id="password_confirmation" type="password_confirmation" name="password_confirmation"
                    class="w-full" id="password_confirmation" pInputText required
                    formControlName="password_confirmation">
                @if (errorMessages['password_confirmation'])
                {
                <br>
                <small class="p-error" *ngFor="let message of errorMessages['password_confirmation']">{{ message
                    }}<br></small>

                }
            </div>
            <p-divider></p-divider>
            }
            <div class="field">
                <label for="is_administrator">Benutzergruppe</label>
                <p-selectButton id="is_administrator" name="is_administrator" [options]="adminOptions"
                    formControlName="is_administrator" class="w-full"></p-selectButton>
            </div>
        </div>
        <p-divider></p-divider>
        <div class="p-fluid">
            <p-button label="Daten speichern" (click)="updateUser()" icon="pi pi-user-edit"
                [disabled]="userEditForm.status == 'INVALID'"></p-button>
        </div>
    </form>
    <p-divider></p-divider>
    @if (userEditForm.value.usersid != "") {
    <form (ngSubmit)="savePassword()" [formGroup]="passwordForm">
        <h4>Kennwort ändern</h4>
        <div class="p-fluid p-formgrin p-grid">
            <div class="field p-col">
                <label for="password">Passwort</label>
                <input id="password" type="password" name="password" id="password" formControlName="password" pInputText
                    required>
                <!-- <div *ngIf="formerror.password_confirmation"><small class="p-error">{{ formerror.password_confirmation[0] }}</small></div> -->
            </div>
            <div class="field p-col">
                <label for="password_confirmation">Passwort wiederholen</label>
                <input id="password_confirmation" type="password" name="password_confirmation"
                    formControlName="password_confirmation" id="password_confirmation" pInputText required>
            </div>
            @if (errorMessages['password_confirmation'])
            {
            <br>
            <small class="p-error" *ngFor="let message of errorMessages['password_confirmation']">{{ message
                }}<br></small>

            }
        </div>

        <div class="p-fluid">
            <p-button label="Passwort speichern" (click)="savePassword()" icon="pi pi-save"></p-button>
        </div>
    </form>
    }
</div>
}